import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";

import type { DealerAdminFormPayload } from "modules/DealerDetails";

const FormHelper = createFormHelper<DealerAdminFormPayload>();

type ConfigurationProps = {
  tabId: string;
};

export const Configuration = ({ tabId }: ConfigurationProps) => {
  const { t } = useTranslation();

  return (
    <Element name={tabId} className="dealer-details-section">
      <div className="section-title">
        <div>
          <Icon className="sliders" />
        </div>
        <span className="section-title-text">{t("v8_configuration", "Configuration")}</span>
      </div>
      <div className="dealer-details-subheading">{t("v8_configuration", "Configuration")}</div>
      <Form.Field>
        <FormHelper.Field.Checkbox name="can_add_users" label={t("v8_can_add_users", "Can add users")} />
      </Form.Field>
      <Form.Field>
        <FormHelper.Field.Checkbox name="dbb_enabled" label={t("v8_dbb", "DBB")} />
      </Form.Field>
      <Form.Field>
        <FormHelper.Field.Checkbox name="custom_domain_enabled" label={t("v8_custom_domain", "Custom Domain")} />
      </Form.Field>
      <Form.Field>
        <FormHelper.Field.Checkbox name="enable_car_ready" label={t("v8_car_return_time", "Car Return Time")} />
      </Form.Field>
      <Form.Field>
        <FormHelper.Field.Checkbox name="advised_critical_history_enabled" label={t("v8_advised_critical_history", "Advised and critical history")} />
      </Form.Field>
    </Element>
  );
};
